import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot,CanDeactivate, RouterStateSnapshot } from 
'@angular/router'; 
import { Observable, from } from 'rxjs';
import {Router} from '@angular/router';
import {LocalService} from '../services/local.service'


export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({providedIn:"root"})
export class AuthGuardService implements CanActivate {

  constructor(private myRoute: Router,private local:LocalService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      //var date = new Date();
      //var ms = date.getDate()+"/"+(1+date.getMonth())+"/"+date.getFullYear()
    if (this.local.getString("token") != undefined) {
      return true;
    }else{
      this.myRoute.navigate(["/"]);
      return false; 
    }
  }


/*   canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    // if there are no pending changes, just allow deactivation; else confirm first
    return component.canDeactivate() ?
      true :
      // NOTE: this warning message will only be shown when navigating elsewhere within your angular app;
      // when navigating away from your angular app, the browser will show a generic warning message
      // see http://stackoverflow.com/a/42207299/7307355
      confirm('WARNING: Quote is not saved . Press Cancel to go back and save these changes, or OK to lose these changes.');
  } */
}
